import React, { Fragment } from "react"

import NewsPost from "."

const IRPost: React.FC = (props) => {
  return (
    <Fragment>
      <NewsPost {...props} />
    </Fragment>
  )
}

export default IRPost
